import { colors, colorsBankee } from "themes/palette/colors"
import { getColorApp } from "utils/color"

export const dashboardTitleSx = {
  fontSize: "22px",
  lineHeight: "128%",
  letterSpacing: "-0.22px",
  fontWeight: 700,
}

export const sectionToggleChipSx = (isSelected: boolean) => ({
  height: "auto",
  p: "8px 16px",
  border: "none",
  borderRadius: "16px",
  bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
  color: isSelected
    ? "mockup.neutral100"
    : getColorApp(colors.primary60, colorsBankee.primary30),
  "&:hover, &.MuiChip-clickable:hover": {
    bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
  },
  "&.Mui-focusVisible": {
    bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
    outline: "2px solid",
    outlineColor: "mockup.primary60",
    outlineOffset: "2px",
  },
  "& .MuiChip-label": {
    p: 0,
    fontSize: "14px",
    fontWeight: isSelected ? 500 : 700,
    lineHeight: "128%",
  },
})
